import {Box, Stack, Typography} from "@mui/material";
import {Smartphone, RotateCw} from "lucide-react";
import {useAppSelector} from "../app/store/hooks.ts";
import {isMobileChecker} from "../utils/IsMobileChecker.ts";

export const MobileOnlyWidget = () => {
    const platform = useAppSelector((state) => state.app.platform) || 'unknown';
    const isMobile = isMobileChecker(platform);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100dvh',
                width: '100%',
                background: 'linear-gradient(180deg, rgb(137, 57, 94) 5%, rgb(53, 25, 40) 58%, rgb(0, 0, 0) 93%)',
            }}
        >
            <Stack
                direction="column"
                spacing={3}
                alignItems="center"
                sx={{
                    textAlign: 'center',
                    px: 4,
                }}
            >
                {!isMobile ? (
                    <>
                        <Smartphone
                            size={80}
                            color="white"
                            strokeWidth={1.5}
                        />
                        <Typography
                            variant="h4"
                            color="white"
                            sx={{fontWeight: 600}}
                        >
                            Mobile Only
                        </Typography>
                        <Typography
                            variant="body1"
                            color="white"
                            sx={{opacity: 0.8, maxWidth: 400}}
                        >
                            This app is designed for mobile devices. Please open it on your smartphone.
                        </Typography>
                    </>
                ) : (
                    <>
                        <RotateCw
                            size={80}
                            color="white"
                            strokeWidth={1.5}
                        />
                        <Typography
                            variant="h4"
                            color="white"
                            sx={{fontWeight: 600}}
                        >
                            Rotate Your Device
                        </Typography>
                        <Typography
                            variant="body1"
                            color="white"
                            sx={{opacity: 0.8, maxWidth: 400}}
                        >
                            Please rotate your device to portrait mode for the best experience.
                        </Typography>
                    </>
                )}
            </Stack>
        </Box>
    );
};
